<template>
  <el-dialog
    class="btn-close"
    :title="dialogTitle"
    :append-modelody="true"
    :modal-append-to-body="false"
    :visible.sync="dialogVisible"
    custom-class="specil-dialog"
    width="500px"
    :before-close="handleClose"
  >
    <div class="dialog-box">
      <div class="icon">
        <i class="iconfont iconbuoumaotubiao21"></i>
      </div>
      <div class="info">
        <div class="t">您不需要注册</div>
        <div class="b">
          直接使用招聘企业/机构发给您的考试路径和账号登录即可参加考试！
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClose">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: ['dialogVisible', 'dialogTitle'],
  methods: {
    handleClose(done) {
      this.$emit('onCancel')
    },
  },
}
</script>
<style lang="scss" scoped>
.dialog-box {
  display: flex;
  padding: 20px 30px;
  font-weight: 300;
  .icon {
    padding: 30px 40px 0px 0px;
    .iconfont {
      font-size: 80px;
      color: #29bdb9;
    }
  }
  .info {
    .t {
      color: #29bdb9;
      font-size: 20px;
    }
    .b {
      padding: 10px 0px 0px;
      line-height: 30px;
      white-space: initial;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/confirm-dialog.vue